
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Chart from 'vue-apexcharts';

@Component({
  name: 'MultiLineChart',
  components: {Chart},
})
export default class MultiLineChart extends Vue {
  @Prop()
  series!: { name: string, data:number[], color: string }[];

  @Prop()
  labels!: string[];

  @Prop()
  loading!: boolean;

  data: [] = [];
  chartOptions = {
    colors: ['#546E7A'],
    chart: {
      type: 'line',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 1.8
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      hideOverlappingLabels: true,
      categories: this.series,
      title: {
        text: 'Data',
      },
    },
    yaxis: {
      title: {
        text: 'Value [EUR]',
      },
    },
  };

  created() {
    this.chartOptions = {
      ...this.chartOptions,
      xaxis: {
        hideOverlappingLabels: true,
        categories: this.series,
        title: {
          text: this.$t('SYSTEM_DATE') as string,
        },
      },
      yaxis: {
        title: {
          text: `${this.$t('SYSTEM_VALUE')} [EUR]`,
        },
      },
    };
  }

  @Watch('labels')
  onCategoriesChanged(newValues: string[]) {
    this.setChartCategories(newValues);
  }

  @Watch('series')
  onSeriesChanged(newValues: { name: string, data:number[], color: string }[]) {
    this.chartOptions = {
      ...this.chartOptions,
      // colors: newValues.map(item => item.color)
    }
  }

  setChartCategories(dates: string[]) {
    this.chartOptions = {
      ...this.chartOptions,
      xaxis: {
        // @ts-ignore
        categories: [...dates],
      },
    };
  }
}
